const svg = `
      <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 1L8.75 8.5L1.25 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

class Upsell {
  constructor () {
    this.load();
  }

  load () {
    document.addEventListener("DOMContentLoaded", () => {
      this.initLoader();
    });
  }

  initLoader () {
    const elementReady = selector => new Promise(resolve => {
      const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector)); // Промис выполнен, элемент найден
          obs.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });

    (async () => {
      const element = await elementReady(".ppa-prod-container-grid");
      this.initNodeUpsell(element);
      this.initUpsellSlide();
      return false;
    })();
  }

  initNodeUpsell () {
    this.initNodeSlider();
    this.initNodeButton();
    this.initEventCheckbox();
  }

  initEventCheckbox () {
    const checkboxes = document.querySelectorAll(".js-upsell-slider .ppa-add-checkbox-input");
    const addonCheckboxes = document.querySelectorAll(".js-event-checkbox .ppa-add-checkbox-input");
    checkboxes.forEach((checkbox, key) => {
      checkbox.addEventListener("change", () => {
        addonCheckboxes[key].click();
      });
    });
  }

  cloneCheckbox () {
    const enetBlockNode = document.createElement("div");
    enetBlockNode.classList.add("js-event-checkbox");
    document.querySelector("lb-upsell-product-page-addon.hydrated").appendChild(enetBlockNode);
    const checkbox = document.querySelectorAll(".ppa-add-checkbox-cont-grid");
    checkbox.forEach(el => {
      document.querySelector(".js-event-checkbox").appendChild(el);
    });
  }

  initNodeSlider () {
    const slider = document.querySelector(".ppa-prod-container-grid-margin").parentNode;
    const sliderNode = slider.cloneNode(true);
    this.cloneCheckbox();
    slider.innerHTML = "<div class=\"js-upsell-slider\"></div>";
    document.querySelector(".js-upsell-slider").appendChild(sliderNode);
    document.querySelectorAll(".ppa-prod-container-grid").forEach((el, key) => {
      el.classList.add("swiper-slide");
      el.querySelector('.ppa-add-checkbox-input').id = 'upsell-' + key;
      el.querySelector('.ppa-add-checkbox-cont-label').setAttribute('for', 'upsell-' + key);
    });
    document.querySelector(".js-upsell-slider .lb-upsell-ppa-grid").classList.add("swiper-wrapper");
  }

  initNodeButton () {
    this.setNodeButton(["prev", "next"]);
  }

  setNodeButton (navs) {
    navs.forEach(nav => {
      let button = document.createElement("button");
      button.setAttribute("type", "button");
      button.innerHTML = svg;
      button.className = `js-upsell-arrow-${nav} upsell-arrow-${nav}`;
      document.querySelector(".js-upsell-slider").parentNode.appendChild(button);
    });
  }

  initUpsellSlide () {
    const idf = new Swiper(".js-upsell-slider", {
      loop: false,
      spaceBetween: 14,
      navigation: {
        nextEl: ".js-upsell-arrow-next",
        prevEl: ".js-upsell-arrow-prev"
      },
      breakpoints: {
        0: {
          slidesPerView: "auto"
        },
        640: {
          slidesPerView: 3
        }

      }
    });
    return false;
  }

}

var upsell = new Upsell();

